import { render, staticRenderFns } from "./SetNewPasswordSuccess.vue?vue&type=template&id=58ade4d4&scoped=true&"
import script from "./SetNewPasswordSuccess.vue?vue&type=script&lang=js&"
export * from "./SetNewPasswordSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPasswordSuccess.vue?vue&type=style&index=0&id=58ade4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ade4d4",
  null
  
)

export default component.exports